import styles from "./ProductBox.module.scss";
import Button from "@/Atoms/Input/Button";
import React from "react";

export interface ProductBoxProps {
  title: string;
  subtitle: string;
  selected: boolean;
  onClick: () => void;
  iconType?: "checkbox" | "radio" | "none";
  price?: string;
  hidePrice?: boolean;
  hideButton?: boolean;
  hideCheckbox?: boolean;
  checkboxPosition?: "left" | "right";
  buttonText?: string;
  className?: string;
  image?: any
  backgroundImage?: any
  style?: any
  children?: React.ReactNode
}

export default function ProductBox(
{
  title,
  subtitle,
  selected,
  onClick,
  iconType = "checkbox",
  price,
  hidePrice = false,
  hideButton = false,
  hideCheckbox = false,
  checkboxPosition = "right",
  buttonText,
  className = "",
  image,
  backgroundImage,
  children,
  style,
  ...props
}: ProductBoxProps) {


  return <div
    className={`${styles.box} ${selected ? styles.active : ""} ${className}`}
    onClick={onClick}
    style={{...(style ?? {}), backgroundImage: backgroundImage ? `url('${backgroundImage}')` : undefined}}
    data-selected={selected}
    {...props}
  >
    <div className={`${styles.header} ${checkboxPosition === "left" ? styles.checkboxLeft : ""}`}>
      <h3>{title}</h3>
      {!hideCheckbox && <div className={styles.checkbox}></div>}
    </div>

    <div className={styles.subtitle}>
      <p>{subtitle}</p>
    </div>
    {image && <img src={image} alt={''} />}
    {!hidePrice && price && <p className={"mt-5"}>vanaf {price}</p>}
    {!hideButton && <Button outlined>{buttonText || title}</Button>}
    {children}
  </div>
}
